module.exports = [
  {
    type: 'text',
    name: 'firstName',
    label: 'First Name *',
    value: '',
    required: true,
  },
  {
    type: 'text',
    name: 'lastName',
    label: 'Last Name *',
    value: '',
    required: true,
  },
  {
    type: 'email',
    name: 'email',
    label: 'Email *',
    value: '',
    required: true,
  },
  {
    type: 'tel',
    name: 'phone',
    label: 'Phone *',
    value: '',
    required: true,
  },
  {
    type: 'text',
    name: 'postcode',
    label: 'Postcode *',
    value: '',
    required: true,
  },
  {
    type: 'select',
    name: 'timeframeToPurchase',
    label: 'Timeframe To Purchase *',
    value: '',
    required: true,
    options: [
      { label: 'Select a timeframe', value: '', disabled: true, selected: true },
      { label: 'Now', value: 'Now' },
      { label: '0 - 3 Months', value: '0 - 3 months' },
      { label: '3 - 6 Months', value: '3 - 6 months' },
      { label: 'Just Looking', value: 'Just looking' },
      { label: 'First Release', value: 'First release' },
      { label: 'Subsequent Release', value: 'Subsequent release' },
    ]
  },
  {
    type: 'checkbox',
    name: 'optIn',
    label: 'I want to receive further information via email',
    value: '',
    required: false,
  },  
  {
    type: 'checkbox',
    name: 'terms',
    label: `I have read and understood the <a class="underline" href="${process.env.VUE_APP_PRIVACY_URL}" target="_blank">privacy policy</a> *`,
    value: '',
    required: true,
  },  
]